export default "<ckeditor [editor]=\"Editor\" data=\"<p>Hello, world!</p>\">\n</ckeditor>";